import { b } from './chunk-IMSWER4T.js';

var r=class extends b{URL="actionTypes"};

export { r as a };
//# sourceMappingURL=chunk-ITY24JYJ.js.map
//# sourceMappingURL=chunk-ITY24JYJ.js.map